export default __webpack_public_path__ + "static/images/Sana_1_thumb.png";